import { useQuery } from "react-query";
import SchemaService from "../api/services/SchemaService";

export const useBondIndemnitorFormSchema = (queryKey: string) => {
  const { data, isLoading, refetch, isError, error } = useQuery(queryKey, async () =>
    await SchemaService.getBondIndemnitorSchema()
  );

  return {
    bondIndemnitorSchema: data?.data?.schema,
    isBondIndemnitorSchemaLoading: isLoading,
    bondIndemnitorSchemaError: error,
    isBondIndemnitorSchemaError: isError,
    fetchBondIndemnitorSchema: refetch
  }
}